import { IUserStatus } from "../common";

export const userConstants: IUserStatus = {
  GET_PROFILE_REQUEST: "USERS_PROFILE_REQUEST",
  GET_PROFILE_SUCCESS: "USERS_PROFILE_SUCCESS",
  GET_PROFILE_FAILURE: "USERS_PROFILE_FAILURE",

  GET_USER_REQUEST: "USERS_DATA_REQUEST",
  GET_USER_SUCCESS: "USERS_DATA_SUCCESS",
  GET_USER_FAILURE: "USERS_DATA_FAILURE",
};

